export default "__VITE_ASSET__UUa8ULcg__"